import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import { DesignTemplateProvider } from '../../contexts/DesignTemplateContext';
import { subscribeAlerts, subscribeAlertDesignTemplate, closeItem } from '../../utils/alertBridge';
import './AlertHost.css';

/* [2026-09-27] 사이트 알림창 주인 — utils/alertBridge.js 가 줄 세운 알림·확인을 공용 알림창(Modal — 운영사 로고)으로 하나씩 띄운다.
   - 앱 맨 바깥(App 의 AppContent 옆)에 한 번만 둔다. WHY: 앱 화면(AppContent)은 로딩 중·도메인 권한 확인 중·로그인 화면으로
     보내기·점검 중일 때 본 화면을 그리지 않고 먼저 끝나는데, 그 안에 두면 그동안 온 알림(예: 로그아웃 뒤 로그인 화면의 안내)이
     붙을 곳이 없어 보이지 않았다(2026-09-27 루미나 비로그인 실측). 맨 바깥은 어떤 경우에도 붙어 있다.
   - 그래서 디자인 정보를 화면 안쪽에서 물려받지 못한다 — 앱이 불러온 사이트 디자인(로고)을 다리가 넘겨주고
     (setAlertDesignTemplate), 여기서 공용 알림창에 다시 쥐여 준다.
   - 브라우저 기본 알림창은 항상 모든 화면 위에 떴다. 이 창도 게임 화면·다른 팝업 위에 뜨도록 전용 층을 쓴다(AlertHost.css).
   - 사이트 로고 정보가 아직 오지 않았으면 최대 3초 기다렸다가 띄운다 — 그 사이 로고 없는 창(디자인1 은 기본 로고)이
     잠깐 비치지 않게. 그래도 오지 않으면(조회 실패) 기다리지 않고 띄우고, 로고 정보가 오는 즉시 사이트 로고로 바뀐다
     (메시지를 잃지 않는 것이 우선).
   - 키보드(초점 "확인"·Esc·뒤 화면으로 새지 않기)는 공용 알림창이 utils/dialogKeyboard.js 로 처리한다(2026-09-28). */
const LOGO_WAIT_MS = 3000;

const AlertHost = () => {
  const [items, setItems] = useState([]);
  const [designTemplate, setDesignTemplate] = useState(null);
  const [waited, setWaited] = useState(false);

  useEffect(() => subscribeAlerts(setItems), []);
  useEffect(() => subscribeAlertDesignTemplate(setDesignTemplate), []);
  useEffect(() => {
    const t = setTimeout(() => setWaited(true), LOGO_WAIT_MS);
    return () => clearTimeout(t);
  }, []);

  const front = (designTemplate || waited) && items.length > 0 ? items[0] : null;
  if (!front) return null;

  const isConfirm = front.kind === 'confirm';
  return (
    <DesignTemplateProvider value={designTemplate}>
      <Modal
        id="siteAlertModal"
        isOpen
        text={front.text}
        type={isConfirm ? 'confirm' : 'alert'}
        onConfirm={isConfirm ? () => closeItem(front, true) : undefined}
        onClose={() => closeItem(front, false)}
      />
    </DesignTemplateProvider>
  );
};

export default AlertHost;
